const storage = window.localStorage;
const TokenKey = 'jwt';

export function getToken() {
    return storage.getItem(TokenKey);
}

export function getNameAndValue(name) {
    return storage.getItem(name);
}

export function setToken(token) {
    return storage.setItem(TokenKey, token);
}

export function setNameAndValue(name, value) {
    if (value === undefined || value === null) {
        return storage.removeItem(name);
    }
    const data = JSON.stringify(value);
    return storage.setItem(name, data);
}

export function removeNameAndValue(name) {
    return storage.removeItem(name);
}

export function removeToken() {
    return storage.removeItem(TokenKey);
}
